'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$0024less$0024colon$0024less$0024$0024anon$00241 from "./scala.$less$colon$less$$anon$1.js";
var $p;
/** @constructor */
function $c_s_$less$colon$less$() {
  this.N = null;
  $n_s_$less$colon$less$ = this;
  this.N = new $j_scala$002e$0024less$0024colon$0024less$0024$0024anon$00241.$c_s_$less$colon$less$$anon$1();
}
export { $c_s_$less$colon$less$ as $c_s_$less$colon$less$ };
$p = $c_s_$less$colon$less$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_$less$colon$less$;
/** @constructor */
function $h_s_$less$colon$less$() {
}
export { $h_s_$less$colon$less$ as $h_s_$less$colon$less$ };
$h_s_$less$colon$less$.prototype = $p;
var $d_s_$less$colon$less$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_$less$colon$less$, "scala.$less$colon$less$", ({
  rp: 1
}));
export { $d_s_$less$colon$less$ as $d_s_$less$colon$less$ };
var $n_s_$less$colon$less$;
function $m_s_$less$colon$less$() {
  if ((!$n_s_$less$colon$less$)) {
    $n_s_$less$colon$less$ = new $c_s_$less$colon$less$();
  }
  return $n_s_$less$colon$less$;
}
export { $m_s_$less$colon$less$ as $m_s_$less$colon$less$ };
